export const nextStepsTranslations = {
  en: {
    hero: {
      badge: 'Standalone Course',
      title: 'Scaling & Growth',
      subtitle: 'Take your products from launch to sustainable growth',
      note: 'This is a separate course, not included in the Full Program'
    },
    content: {
      badge: '📈 Growth Mastery',
      description: 'Learn the strategies and techniques to scale your AI-powered products. From user acquisition to performance optimization, master the skills needed to grow your digital business.'
    },
    features: {
      title: 'What You\'ll Learn',
      items: [
        {
          title: 'Growth Strategies',
          description: 'Proven methods to acquire and retain users for your products'
        },
        {
          title: 'Performance Optimization',
          description: 'Make your applications faster and more efficient at scale'
        },
        {
          title: 'Analytics & Metrics',
          description: 'Track the right metrics and make data-driven decisions'
        },
        {
          title: 'Monetization',
          description: 'Learn different revenue models and pricing strategies'
        },
        {
          title: 'Infrastructure Scaling',
          description: 'Scale your technical infrastructure to handle growth'
        },
        {
          title: 'Team Building',
          description: 'Build and lead teams as your product grows'
        }
      ]
    },
    roadmap: {
      title: 'Growth Roadmap',
      phases: [
        {
          phase: 'Phase 1',
          title: 'Foundation',
          description: 'Establish core metrics and tracking'
        },
        {
          phase: 'Phase 2',
          title: 'Traction',
          description: 'Find product-market fit and first users'
        },
        {
          phase: 'Phase 3',
          title: 'Scale',
          description: 'Optimize and automate growth channels'
        },
        {
          phase: 'Phase 4',
          title: 'Expand',
          description: 'Enter new markets and verticals'
        }
      ]
    },
    cta: {
      goToDashboard: 'Go to Dashboard',
      backToHome: 'Back to Home',
      startScaling: 'Start Scaling',
      viewRoadmap: 'View Roadmap'
    }
  },
  uk: {
    hero: {
      badge: 'Окремий курс',
      title: 'Масштабування та зростання',
      subtitle: 'Переведіть ваші продукти від запуску до стійкого зростання',
      note: 'Це окремий курс, не входить до Full Program'
    },
    content: {
      badge: '📈 Майстерність зростання',
      description: 'Вивчіть стратегії та техніки масштабування AI-продуктів. Від залучення користувачів до оптимізації продуктивності — опануйте навички для розвитку цифрового бізнесу.'
    },
    features: {
      title: 'Що ви вивчите',
      items: [
        {
          title: 'Стратегії зростання',
          description: 'Перевірені методи залучення та утримання користувачів'
        },
        {
          title: 'Оптимізація продуктивності',
          description: 'Зробіть додатки швидшими та ефективнішими при масштабуванні'
        },
        {
          title: 'Аналітика та метрики',
          description: 'Відстежуйте правильні метрики та приймайте рішення на основі даних'
        },
        {
          title: 'Монетизація',
          description: 'Вивчіть різні моделі доходу та стратегії ціноутворення'
        },
        {
          title: 'Масштабування інфраструктури',
          description: 'Масштабуйте технічну інфраструктуру для обробки зростання'
        },
        {
          title: 'Побудова команди',
          description: 'Будуйте та керуйте командами в міру зростання продукту'
        }
      ]
    },
    roadmap: {
      title: 'Дорожня карта зростання',
      phases: [
        {
          phase: 'Фаза 1',
          title: 'Фундамент',
          description: 'Встановіть основні метрики та відстеження'
        },
        {
          phase: 'Фаза 2',
          title: 'Тяга',
          description: 'Знайдіть product-market fit та перших користувачів'
        },
        {
          phase: 'Фаза 3',
          title: 'Масштаб',
          description: 'Оптимізуйте та автоматизуйте канали зростання'
        },
        {
          phase: 'Фаза 4',
          title: 'Розширення',
          description: 'Виходьте на нові ринки та вертикалі'
        }
      ]
    },
    cta: {
      goToDashboard: 'Перейти до панелі',
      backToHome: 'На головну',
      startScaling: 'Почати масштабування',
      viewRoadmap: 'Переглянути дорожню карту'
    }
  }
};
